// oxlint-disable import/prefer-default-export
import { HeartIcon } from '@coop/icons';
import { useMemo } from 'react';

import { appConfig } from '../../../../../appConfig';
import { useIsEligibleForFavoriteProducts } from '../../../../common/hooks/useFavoriteProducts';
import { useAppSelector } from '../../../../common/hooks/useThunkDispatch';
import { featureFlagsSelectors } from '../../../../common/selectors/featureFlagsSelectors';
import { useIsB2BRoute } from '../../../../common/utils/b2bUtils';
import { filterProfilePopoverLinksBySmartShoppingListFlag } from './HeaderProfileDropdown.utils';
import { b2bLinks, b2cLinks } from './HeaderProfilePopover.utils';

export const useHeaderPopoverLinks = () => {
    const isB2BRoute = useIsB2BRoute();

    const isEligibleForFavoriteProducts = useIsEligibleForFavoriteProducts();

    const isSmartShoppingListEnabled = useAppSelector((state) =>
        featureFlagsSelectors.selectEveryDynamicFlagEnabled(state, ['EnableSmartShoppingList']),
    );

    const links = useMemo(() => {
        const baseLinks = isB2BRoute ? b2bLinks : b2cLinks;
        const linksArray = filterProfilePopoverLinksBySmartShoppingListFlag(
            baseLinks,
            isSmartShoppingListEnabled,
        );

        if (
            isEligibleForFavoriteProducts &&
            appConfig.coopSettings.ecommerce.favoriteProductsPage
        ) {
            linksArray.push({
                id: 'favoriteProducts',
                type: 'link',
                name: 'Favoritprodukter',
                url: appConfig.coopSettings.ecommerce.favoriteProductsPage.url,
                icon: <HeartIcon />,
            });
        }

        return linksArray;
    }, [isB2BRoute, isEligibleForFavoriteProducts, isSmartShoppingListEnabled]);

    return links;
};
